import React, { memo, useCallback } from "react";
import classNames from "classnames";
import "./UniversalCheckbox.scss";

import CheckedIcon from "static/icons/checked.svg";

const UniversalCheckbox = memo(({
  label,
  name,
  checked,
  onChange,
}) => {
  const handleClick = useCallback(() => {
    if (name) {
      onChange?.(!checked, name);
    } else {
      onChange?.(!checked);
    }
  }, [name, checked, onChange]);

  return (
    <div
      className="universal-checkbox"
      onClick={handleClick}
    >
      <div
        className={classNames({
          "universal-checkbox__indicator": true,
          "universal-checkbox__indicator--checked": !!checked,
        })}
      >
        {!!checked &&
          <img src={CheckedIcon} />
        }
      </div>

      {label}
    </div>
  );
});

export default UniversalCheckbox;
